import { useToast as useToastification } from 'vue-toastification'

function useToast() {
  const toast = useToastification()
  return {
    success: toast.success,
    error: toast.error
  }
}

export default useToast
